import { useMutation, useQueryClient } from '@tanstack/react-query'
import supabase from 'sdk/api';

const addReview = async (
    text: string,
    rank: number,
    salon?: string,
    media?: string[],
    name?: string,
    isAnon?: boolean,
    serviceRank?: number,
    specialistRank?: number,
    serviceId?: string,
    teamId?: string
) => {
    if (!text) {
        throw new Error('Comment should not be empty')
    }
    const { data: userData } = await supabase.auth.getSession()

    const { data: reportData, error } = await supabase
        .from('reviews')
        .insert({
            text,
            rank,
            salon,
            user: userData?.session?.user?.id,
            media,
            name: isAnon ? "Anonymous" : name,
            service_rank: serviceRank,
            team_rank: specialistRank,
            service_id: serviceId,
            team_id: teamId
        })
        .select()
        .single();

    if (error) {
        throw new Error(error.message)
    }

    return reportData
}

export default function useAddReview(
    text: string,
    rank: number,
    salon?: string,
    media?: string[],
    name?: string,
    isAnon?: boolean,
    serviceRank?: number,
    specialistRank?: number,
    serviceId?: string,
    teamId?: string
) {
    const queryClient = useQueryClient()

    return useMutation(() => addReview(text, rank, salon, media, name, isAnon, serviceRank, specialistRank, serviceId, teamId), {
        onSuccess: async (res) => {
            queryClient.invalidateQueries({ queryKey: ['reports'] })
            return res
        },
    })
}
